import React, { useEffect } from "react";
import Loading from "../../components/Loading/Loading";
import { useLocation, useHistory } from "react-router-dom";
import { requestHandler } from "../../services/requestHandler";
import { useDispatch } from "react-redux";

export default function Checkout() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const orderId = searchParams.get("orderId");
  const amount = searchParams.get("amount");
  const type = searchParams.get("type");

  const createCharge = async () => {
    try {
      const response = await requestHandler(
        "POST",
        "payment/create-charge",
        { orderId, amount, type },
        dispatch
      );

      if (response?.status) {
        console.log(type, response);
        if (type == "tap") {
          window.location.href = response.data?.transaction?.url;
        }
        if (type == "tamara") {
          sessionStorage.setItem("tamara_order_id", response?.data?.order_id);
          window.location.href = response.data?.checkout_url;
        }
      } else {
        window.location.href = `/payment/response?status=Failed&message="Transaction not Initiated"`;
      }
    } catch (error) {
      console.log("chargeCreated :", error.message);
      history.push(
        `/payment/response?status=Failed&message="Transaction not Initiated"`
      );
    }
  };
  useEffect(() => {
    createCharge();
  }, [search]);

  return <Loading />;
}
